import { render, staticRenderFns } from "./catalogoProc.vue?vue&type=template&id=059072d7&"
import script from "./catalogoProc.vue?vue&type=script&lang=js&"
export * from "./catalogoProc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports